import { useDebounce } from '@chiroup/hooks/useDebounce';
import { useState } from 'react';
import { QueryFunctionContext, useInfiniteQuery } from 'react-query';
import eventLogService, { EventLogClinic } from '../services/eventLog.service';

const useEventLogClinics = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearch = useDebounce(searchQuery);

  const {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery<{ data: EventLogClinic[]; skip?: number; count: number }>(
    ['eventLogClinics', debouncedSearch],
    async (context: QueryFunctionContext) => {
      return eventLogService.listClinics({
        skip: context.pageParam,
        search: debouncedSearch || undefined,
      });
    },
    {
      getNextPageParam: lastGroup => lastGroup?.skip || undefined,
      refetchOnWindowFocus: false,
    }
  );

  const onSearch = (val: string) => {
    setSearchQuery(val);
  };

  return {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
    onSearch,
  };
};

export default useEventLogClinics;
